<template>
    <div>
        <el-dialog v-dialogDrag :visible.sync="visible" width="700px" :close-on-click-modal="false" :before-close="resetform">
            <span slot="title" class="dialog-title">数据源管理</span>
            <div>
                <div style="margin-bottom: 10px">业务系统： {{systemName}} 
                    <el-button size="small" class="bottom_all" style="margin-bottom: 10px; float: right;" @click="add()">
                        <i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
                        添加
                    </el-button>
                    </div>
                <el-table
                    :data="list"
                    border
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="名称"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="dbType"
                    label="数据库类型"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="dbUrl"
                    label="数据库链接">
                    </el-table-column>
                    <el-table-column
                    label="操作">
                        <template slot-scope="scope">
                            <el-button class="bottom_one" size="mini" @click="update(scope.row)">
                            <i class="icon iconfont iconicon_button_modification" style="font-size: 12px;"></i>
                            修改
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="resetform(true)">关 闭</el-button>
            </span>
            </el-dialog>
            <el-dialog v-dialogDrag :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false" :before-close="resetform">
                <span slot="title" class="dialog-title">{{ !!form.id ? '修改': '添加' }}数据源</span>
                <div class="dialoginfo">
                    <el-form ref="dialogForm" :rules="rules" :inline="true" :model="form" label-width="100px">
                        <el-form-item prop="name">
                            <span slot="label" style="color:  #FF0000 ;">名称</span>
                            <el-input v-model="form.name" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="dbType">
                            <span slot="label" style="color:  #FF0000 ;">数据库</span>
                            <el-select v-model="form.dbType" placeholder="请选择" @change="switchDbType">
                                <el-option
                                    v-for="item in dbTypeList"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="dbAccount">
                            <span slot="label">账号</span>
                            <el-input v-model="form.dbAccount" placeholder="请输入" clearable />
                        </el-form-item>
                        <el-form-item prop="dbPassword">
                            <span slot="label">密码</span>
                            <el-input v-model="form.dbPassword" placeholder="请输入" clearable type="password" show-password/>
                        </el-form-item>
                        <el-form-item prop="dbUrl">
                            <span slot="label">数据库链接</span>
                            <el-input v-model="form.dbUrl" placeholder="请输入" clearable/>
                        </el-form-item>
                        <el-form-item prop="dbDriver">
                            <span slot="label">数据库驱动</span>
                            <el-input v-model="form.dbDriver" placeholder="请输入" clearable/>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="resetform()">取 消</el-button>
                    <el-button class="bottom_all" @click="save()">确 定</el-button>
                </span>
            </el-dialog>
    </div>
</template>

<script>

import {
  getDataSourceList,
  saveOrUpdateDataSource
} from "@/api/basedata/business.js";
export default {
    props: ['systemName', 'visible', 'systemId'],
    data() {
        return {
            dbTypeList: ['MySQL', 'Oracle', 'SQLServer'],
            list: [],
            dialogVisible: false,
            form: {
                systemId: '',
                name: '',
                dbType: '',
                dbUrl: '',
                dbDriver: '',
                dbAccount: '',
                dbPassword: ''
            },
            rules: {
                name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                dbUrl: [{ required: true, message: "请输入数据库链接", trigger: "blur" }],
                dbDriver: [{ required: true, message: "请输入数据库驱动", trigger: "blur" }],
                dbAccount: [{ required: true, message: "请输入数据库的账号", trigger: "blur" }],
                dbPassword: [{ required: true, message: "请输入数据库的密码", trigger: "blur" }],
                dbType: [
                    { required: true, message: "请选择数据库类型", trigger: "change" },
                ]
            },
            referList: [
                {
                    driver: 'com.mysql.jdbc.Driver',
                    url: 'jdbc:mysql://ip:port/database?useUnicode=true&characterEncoding=UTF-8&useOldAliasMetadataBehavior=true&autoReconnect=true&failOverReadOnly=false&useSSL=false'
                },
                {
                    driver: 'oracle.jdbc.OracleDriver',
                    url: 'jdbc:oracle:thin:@ip:port:database'
                },
                {
                    driver: 'com.microsoft.sqlserver.jdbc.SQLServerDriver',
                    url: 'jdbc:sqlserver://ip:port; DatabaseName=sample'
                }
            ]
        }
    },
    watch: {
        visible() {
            this.list = []
            this.getList()
        }
    },
    methods: {
        getList() {
            getDataSourceList({systemId: this.systemId}).then(res => {
                console.log(res)
                this.list = res.data
            })
        },
        add() {
            this.dialogVisible = true
            this.form = {
                systemId: this.systemId,
                name: '',
                dbType: '',
                dbUrl: '',
                dbDriver: '',
                dbAccount: '',
                dbPassword: ''
            }
            this.$refs.dialogForm?.resetFields();
        },
        switchDbType() {
            console.log(this.form.dbType)
            let index = this.dbTypeList.indexOf(this.form.dbType)
            if (index >= 0) {
                let item = this.referList[index]
                this.form.dbUrl = item.url
                this.form.dbDriver = item.driver
            }
        },
        save() {
            this.$refs.dialogForm.validate((valid) => {
                if (valid) {
                    saveOrUpdateDataSource(this.form).then(res => {
                        console.log(res)
                        this.dialogVisible = false
                        this.getList()
                        this.$message.success('操作成功')
                    })
                }
            }) 
        },
        update(row) {
            this.form = {...row}
            this.dialogVisible = true
            this.$refs.dialogForm?.resetFields();
        },
        resetform(isMain) {
            if (isMain) {
                this.$emit('close')
            } else {
                this.dialogVisible = false
            }
        }
    }
}
</script>